<template>
    <div :class="['cardBox', $i18n.locale]">
        <p id="page2" class="anchor"></p>
        <p class="cardTitle">{{ $t('teng-tong-qian-zai-feng-xian-ping-gu') }}</p>
        <div class="customTabs">
            <ul class="tabsTitle">
                <li :class="tabinx === 0 ? 'currentTab' : ''" @click="onChange(0)">{{ $t('jing-bu') }}</li>
                <li :class="tabinx === 1 ? 'currentTab' : ''" @click="onChange(1)">{{ $t('bei-bu') }}</li>
                <li :class="tabinx === 2 ? 'currentTab' : ''" @click="onChange(2)">{{ $t('yao-bu') }}</li>
            </ul>
            <p
                class="tips2"
            >{{ tabinx === 0 ? $t('jing-bu-zheng-ti-jie-gou-yi-chang-ping-fen') : tabinx === 1 ? $t('bei-bu-zheng-ti-jie-gou-yi-chang-ping-fen') : $t('yao-bu-zheng-ti-jie-gou-yi-chang-ping-fen') }}</p>
            <div class="rateBox">
                <div class="rateImg">
                    <!-- 颈部 -->
                    <img
                        v-if="tabinx === 0"
                        :src="require(`../../assets/image/pain/cervicalPain_${preStatus}.png`)"
                        alt
                    />
                    <!-- <svg v-if="tabinx === 0" width="70" height="70" viewBox="0 0 120 120" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M60.7227 43.373C63.5339 44.4172 68.9636 50.1682 68.1925 64.8188C67.2287 83.1321 66.9877 88.6743 71.566 97.3489"
                            stroke="#51ED97" stroke-width="8" stroke-linejoin="round" stroke-dasharray="4.8 4.8" />
                        <path
                            d="M23 19C21 21.6667 15.5999 31.4 17.9999 33C20.9999 35 23.9996 33 22.9996 41C23.7996 43.4 28.3329 43 28.9996 43C28.3329 44 24.3996 47.4 25.9996 49C27.9996 51 27.4847 52.0597 26.9996 54C25.9996 58 27.9996 64 41.9996 60C55.9996 56 52.9996 78 51.9996 81C50.9996 84 43.9996 85 43.9996 88C43.9996 91 42.9996 97 37.9996 100"
                            stroke="#5698F5" stroke-width="4" stroke-linejoin="round" />
                        <path d="M94.9997 21C89.9997 27.3333 81.1997 43 85.9997 55C91.9997 70 103 79 102 99"
                            stroke="#5698F5" stroke-width="4" stroke-linejoin="round" />
                        <circle id="shape1" cx="68" cy="60" r="12" :fill="colorLevels[2]" />
                    </svg>-->

                    <!-- 背部 -->
                    <img
                        v-if="tabinx === 1"
                        :src="require(`../../assets/image/pain/thoracicPain_${preStatus}.png`)"
                        alt
                    />
                    <!-- <svg v-if="tabinx === 1" width="70" height="70" viewBox="0 0 120 120" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M60.9639 46.5059V101.928" stroke="#51ED97" stroke-width="8" stroke-linejoin="round"
                            stroke-dasharray="4.8 4.8" />
                        <path
                            d="M49.0002 10V22L38.6079 28C29.7388 27.3333 12.6005 31.4 15.0005 53C15.0005 56.2 13.0002 71 12 78"
                            stroke="#5698F5" stroke-width="4" stroke-linejoin="bevel" />
                        <path
                            d="M69.9993 10V22L80.3916 28C89.2608 27.3333 106.399 31.4 103.999 53C103.999 56.2 105.999 71 107 78"
                            stroke="#5698F5" stroke-width="4" stroke-linejoin="bevel" />
                        <path d="M24 97L33 70L38 87V106" stroke="#5698F5" stroke-width="4" stroke-linejoin="bevel" />
                        <path d="M95 97L86 70L81 87V106" stroke="#5698F5" stroke-width="4" stroke-linejoin="bevel" />
                        <circle id="shape2" cx="61" cy="67" r="13" :fill="colorLevels[preStatus]" />
                    </svg>-->

                    <!-- 腰部 -->
                    <img
                        v-if="tabinx === 2"
                        :src="require(`../../assets/image/pain/lumbarPainMan_${preStatus}.png`)"
                        alt
                    />
                    <!-- <svg v-if="tabinx === 2" width="70" height="70" viewBox="0 0 120 120" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M53.4937 30.8428C55.6624 39.9994 61.06 57.0115 57.5901 66.2645C54.1203 75.5175 53.4937 95.1801 41.2046 115.18"
                            stroke="#51ED97" stroke-width="8" stroke-linejoin="round" stroke-dasharray="4.8 4.8" />
                        <path
                            d="M75.0001 6C74.0001 9.66667 71 19.2 75 24C80 30 85.6001 33.3546 85.6 44.4C85.5999 54.4 84.8667 51.4667 83.2 62.8C81.5333 74.1333 82.2002 102.8 86.2002 110.8"
                            stroke="#5698F5" stroke-width="4" stroke-linejoin="bevel" />
                        <path
                            d="M34.9996 11C30.9996 13.6667 24.1996 23.6 28.9996 42C34.9996 65 37.9991 64 34.9996 82C32.5999 96.4 26 108.667 23 113"
                            stroke="#5698F5" stroke-width="4" stroke-linejoin="bevel" />
                        <circle id="shape3" cx="56.9995" cy="61" r="13" :fill="colorLevels[preStatus]" />
                    </svg>-->
                </div>
                <div class="rateProcess">
                    <p :style="{ color: colorLevels[preStatus] }">
                        <span>
                            {{preScore}}
                            <i>{{ $t('fen') }}</i>
                        </span>
                        <span :style="{ background: colorLevels[preStatus] }">{{dealWith(preStatus)}}</span>
                    </p>
                    <processBar :nums="interval" :currentNum="preScore > 0 ? preScore: 0.1"></processBar>
                </div>
            </div>
            <!-- <p class="tips">低风险，颈部姿势良好</p> -->
        </div>

        <!-- <div class="assessmentView">
            <p class="assessmentTitle"><span>!</span> 颈部肌肉评估</p>
            <div class="assessmentDetail">
        <div class="shapeBox">-->
        <!-- 肌肉群 id为shape*表示需要修改颜色的肌肉 -->
        <!-- <svg width="75" height="75" viewBox="20 15 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M130.688 133.807L130.49 133.523L128.617 130.682C127.64 129.213 127.055 128.375 126.324 127.403C125.02 125.667 123.928 124.718 122.447 124.389L122.21 124.34C120.495 124.042 119.317 123.022 118.361 121.215C116.298 117.329 115.214 113.331 114.212 106.936L113.485 102.106C113.383 101.438 113.287 100.833 113.202 100.248C112.735 97.316 111.994 94.4347 110.989 91.6422L110.669 90.77C109.254 86.9857 108.238 84.9457 106.563 82.9911L106.373 82.7723C105.241 81.4881 104.647 80.3744 104.494 79.0505L104.211 76.3912C104.094 75.1121 103.873 73.8446 103.552 72.6012L103.427 72.1665C102.42 68.8112 102.1 65.7655 102.536 62.7397L102.612 62.2624C103.039 59.7424 102.81 57.1257 102.046 53.8954C101.48 51.5004 100.207 49.4292 98.1267 47.1364C94.9656 43.6533 91.4847 41.8719 87.3416 41.9344H86.9624C85.9125 41.9799 84.9814 41.8037 83.4646 41.3406L82.4203 41.011C81.2487 40.6417 80.4139 40.1275 78.7414 38.8547L77.7622 38.1046C77.4565 37.8773 77.2188 37.7012 76.9839 37.5364L76.6245 37.2977C75.4925 36.5562 75.003 35.5192 74.7369 33.6412C74.536 32.2207 74.7002 31.1354 75.3369 28.9676L75.7274 27.6664C76.0102 26.7925 76.2194 25.8963 76.3529 24.9873C76.3796 24.8941 76.4271 24.8084 76.4918 24.7365C76.5566 24.6646 76.6368 24.6085 76.7264 24.5725C78.4527 23.6292 79.0526 22.2002 79.1772 19.7739L79.2027 19.2454L79.2394 18.7397C79.2989 17.7368 79.1375 17.0691 78.5036 16.5663L78.3706 16.4668C77.6461 15.9668 77.4679 15.4525 77.4339 14.0973V13.8644C77.3773 9.97208 76.0981 6.80994 73.4097 4.28989C69.5609 0.684537 61.9964 1.44879 59.0193 5.79282C57.2421 8.3839 56.3931 10.8869 56.5515 13.6058L56.5798 13.961C56.6619 14.8758 56.611 15.2707 56.2572 15.6656L56.1752 15.7537C54.7092 17.2538 54.2904 20.254 55.1451 22.328L55.2667 22.6121L55.2837 22.6462C55.8497 23.8167 56.2176 24.3253 57.0468 24.6747C57.1817 24.7466 57.2991 24.8476 57.3906 24.9704C57.4821 25.0932 57.5454 25.2348 57.576 25.385C58.7674 28.9676 59.2428 31.9195 58.9372 34.8601C58.9077 35.339 58.7066 35.7911 58.3712 36.1329C54.0895 40.3235 50.4105 42.2157 45.8373 41.906C44.3714 41.8066 42.9252 42.1901 41.3574 42.9487C34.9051 46.108 31.4525 51.4038 30.9799 58.6344L30.9007 60.143C30.8809 60.5379 30.8752 60.8021 30.8781 61.1118C30.8697 61.8142 30.9496 62.5148 31.1158 63.1972L31.1922 63.4671C31.6987 65.1433 31.6818 66.8906 31.1922 68.8652C30.6007 71.2801 30.1026 73.6183 29.7008 75.9167L29.6414 76.3031C29.6102 76.5219 29.5876 76.752 29.5593 77.0532L29.497 77.8458C29.3527 79.7551 29.1348 80.6472 28.4442 81.491C26.0473 84.4287 24.2559 87.7982 22.7843 91.9036C21.5718 95.4224 20.699 99.0502 20.1779 102.737L19.8185 105.16C18.8874 111.342 18.1516 114.72 16.7734 118.451C15.3953 122.181 13.8699 124.005 10.9607 124.593C10.324 124.718 9.82872 125.056 9.00802 125.789C7.46003 127.162 6.46105 128.488 4.72628 131.293L3.37354 133.492C3.1501 133.801 3.02042 134.169 3 134.551C3.00025 134.721 3.03441 134.889 3.10053 135.045C3.16664 135.201 3.26335 135.342 3.38487 135.46C3.52833 135.612 3.70665 135.725 3.90409 135.79C4.10153 135.856 4.31201 135.871 4.51686 135.835C4.71306 135.8 4.9035 135.738 5.08285 135.651L5.49319 135.463L5.52715 135.449C5.94386 135.277 6.29697 134.979 6.53746 134.597C6.96999 133.946 7.48458 133.354 8.06845 132.835L8.74765 132.176L9.0901 131.827L9.21177 131.693C9.66174 131.213 9.82871 131.125 10.0608 131.281C10.2928 131.437 10.3438 131.625 10.2561 132.045L10.2051 132.247L10.0608 132.736C10.0042 132.943 9.92845 133.145 9.83439 133.338L6.67046 139.438L5.5611 141.563C5.07435 142.501 4.89325 143.126 5.04606 143.864C5.32906 145.183 6.21483 145.697 7.36946 144.819C8.03169 144.294 8.58136 143.639 8.9854 142.896L10.3126 140.594C10.7824 139.787 11.1277 139.216 11.5295 138.586L11.6512 138.401C11.7022 138.321 11.762 138.248 11.8295 138.182L11.8691 138.151C11.9229 138.111 11.9229 138.111 11.9965 138.165C12.0191 138.179 12.0248 138.216 11.9965 138.344L11.9144 138.594L11.1928 140.6L9.12406 146.436C8.87786 147.12 8.90049 147.623 9.33348 148.14C10.3353 149.345 11.7786 149.032 12.4266 147.461L12.7096 146.794C12.9275 146.225 13.1483 145.657 13.4567 144.805L14.385 142.248C14.4557 142.055 14.5236 141.876 14.5887 141.705L14.9113 140.878C14.9566 140.762 14.9934 140.645 15.0415 140.475L15.1293 140.131C15.2849 139.543 15.3585 139.435 15.4603 139.464C15.6132 139.506 15.667 139.654 15.6302 140.114L15.5509 140.796C15.531 140.943 15.5206 141.091 15.5198 141.239V141.276L15.4773 141.381L15.4519 141.441C15.4002 141.545 15.3585 141.653 15.3273 141.765L14.7331 144.606C14.5095 145.703 14.368 146.444 14.2208 147.294C14.0595 148.206 14.4557 149.038 15.3528 149.282C16.2018 149.51 16.7508 149.018 17.1357 148.146C17.6243 147.14 17.9801 146.074 18.1941 144.975L18.4148 143.657C18.5711 142.497 18.8402 141.355 19.2185 140.248L19.3346 139.941L19.3827 139.796L19.4053 139.955C19.4087 139.978 19.4134 140.001 19.4195 140.023L19.4365 140.091C19.6629 140.944 19.7195 141.645 19.7195 143.04V144.612L19.7393 145.373C19.7789 146.345 20.1185 146.936 21.058 146.902C21.907 146.873 22.3542 146.211 22.524 145.22L22.6145 144.563L22.7079 143.827C22.882 142.668 22.9398 141.495 22.8806 140.324L22.8636 140.086C22.7532 138.785 22.8975 137.699 23.3871 135.557L23.6701 134.279C23.9531 133.043 24.1965 131.892 24.4993 130.466L25.985 123.397L26.1633 122.499C27.0972 117.851 27.7 115.681 28.948 113.343L30.1677 111.109C32.5732 106.691 33.9938 103.904 35.3636 100.816L35.8022 99.8246C37.3275 96.3755 37.9275 94.6509 38.1086 92.5087L38.1284 92.2673C38.2557 90.6935 38.5663 89.1402 39.0538 87.6391L39.2859 86.9061C39.9368 84.9173 40.6782 83.082 42.1328 79.7636L43.3893 76.8998C43.427 76.8119 43.4592 76.7218 43.4856 76.6299L43.579 76.2747C43.7007 75.8116 43.7516 75.7406 43.8931 75.7548C44.0346 75.769 44.1421 75.8883 44.2525 76.3401L44.3515 76.7691C44.3515 76.8344 44.3826 76.8912 44.3968 76.9452L44.4478 77.0986C44.4478 77.0816 44.4478 77.0759 44.4478 77.0844V77.1157C44.4478 77.1753 44.4478 77.2208 44.4478 77.2663L44.6317 78.0731C44.6968 78.3771 44.7676 78.7124 44.8553 79.1471L45.1383 80.6188C45.5854 82.8263 45.8939 84.0281 46.3891 85.2583L46.5533 85.6532C47.4023 87.642 47.4956 89.5711 47.074 92.2104L46.9325 93.0258L46.5221 95.1254C46.4882 95.293 46.4486 95.4635 46.4033 95.668L46.1939 96.5374C45.7637 98.3273 45.5967 99.2848 45.6279 100.387L45.6562 101.575C45.6562 102.22 45.6562 102.907 45.6562 103.848L45.6307 107.39C45.6183 108.076 45.5028 108.756 45.2882 109.408L44.8949 110.686L44.4251 112.186C43.5167 115.124 43.1318 116.661 42.8941 118.59L42.8177 119.258C42.8064 119.371 42.7951 119.488 42.7837 119.607L42.696 120.61L42.4753 123.536C42.4272 124.105 42.3847 124.548 42.3309 125.014L42.3083 125.19C41.7423 129.858 41.397 134.281 41.2952 138.569L41.1961 144.163C41.1225 149.118 41.1961 151.834 41.6291 154.894L42.0394 157.794L42.2234 159.127C42.7017 162.476 43.0526 164.317 43.661 166.326L43.8195 166.832C44.5242 169.028 44.8185 171.093 44.643 173.011C44.2728 176.643 44.1263 180.294 44.2044 183.944L44.2468 185.117C44.2978 185.919 44.2617 186.724 44.1393 187.518L43.9242 188.822C42.8601 195.41 42.5092 199.706 42.9167 204.331L43.0243 205.513C43.2733 208.039 43.6242 210.423 44.2978 214.36L45.26 219.923C45.4892 221.284 45.6646 222.364 45.8259 223.409L46.2646 226.441L46.4174 227.489C46.6636 229.194 46.7796 230.197 46.8447 231.316V231.526C46.9002 232.853 46.8756 234.181 46.7712 235.504L46.6495 237.518C46.6495 237.76 46.6268 237.973 46.6155 238.206C46.5196 239.771 46.585 241.342 46.8108 242.894C46.8384 243.16 46.8005 243.429 46.7004 243.678L46.5589 244.087C45.9165 245.939 44.8977 247.496 43.013 249.786C40.8565 252.406 41.598 255.36 44.7449 256.554C47.4815 257.596 48.837 257.852 50.6341 257.292C50.8448 257.23 51.0675 257.219 51.2833 257.261C51.4991 257.303 51.7016 257.396 51.8736 257.534C52.7226 258.216 53.5093 258.119 54.4489 257.443C55.1952 256.926 55.8154 256.246 56.2629 255.454C56.7998 254.475 57.0739 253.373 57.0581 252.255V251.388L57.01 248.743C56.9789 246.471 57.044 245.078 57.293 243.652L57.3355 243.414C57.8166 240.84 57.7345 238.737 56.9675 236.626L56.8345 236.274C56.1301 234.567 55.8288 232.719 55.9544 230.876L56.0082 230.291C56.2912 227.287 56.8572 224.674 58.1448 219.46L58.6542 217.415C60.0692 211.752 60.5107 209.102 60.3324 205.812L60.3154 205.528C60.2107 203.928 59.9956 202.644 59.4664 200.129L58.9995 197.967L58.9599 197.774C58.0373 193.331 58.0599 189.819 59.274 186.41L59.4155 186.032C60.4644 183.206 60.9825 180.209 60.9437 177.193V176.591C60.9336 175.927 60.9619 175.263 61.0285 174.602L61.0738 174.173C61.1531 173.474 61.2436 172.861 61.4163 171.861L61.7191 170.133L62.0275 168.551L62.2172 167.582C62.4181 166.618 62.5673 165.644 62.6643 164.664L62.6813 164.46C62.8313 162.644 63.0378 160.951 63.3124 159.36L63.6633 157.419L64.7613 150.967L65.3273 147.842C66.2272 142.87 66.5527 140.171 66.5017 137.077V136.475C66.4819 135.864 66.5923 135.691 67.0281 135.71C67.3479 135.71 67.4215 135.827 67.4526 136.372L67.5177 138.114L67.5573 139.307L67.5913 140.179C67.632 141.462 67.7444 142.742 67.928 144.012L69.2949 152.317C69.6487 154.484 69.8949 156.061 70.1439 157.715L70.3873 159.419C70.4524 159.885 70.5175 160.394 70.6024 161.084L70.8061 162.746C71.1146 165.235 71.3551 166.857 71.6806 168.448L71.8617 169.301L72.0343 170.031C72.2757 170.894 72.4312 171.779 72.4984 172.673V172.841C72.6569 178.665 73.2229 182.867 74.6237 186.859L74.7822 187.302C75.3992 188.981 75.7076 190.478 75.6652 191.873C75.5329 195.03 75.0661 198.163 74.2728 201.22L74.1002 201.911C73.1861 205.513 73.3248 209.031 74.2898 213.809L74.4002 214.346C74.5869 215.23 74.7624 215.994 75.0312 217.085L75.917 220.608C77.0122 225.026 77.4226 227.285 77.5499 230.106C77.6829 233.106 77.4707 235.22 76.6783 237.209L76.5538 237.507C75.9768 238.911 75.8281 240.456 76.1265 241.945L76.1944 242.294C76.7532 245.015 76.9379 247.799 76.7434 250.57L76.6896 251.201C76.4991 252.881 76.8609 254.577 77.7197 256.031C78.7244 257.736 80.2413 258.267 82.0298 257.582L82.2307 257.5C82.5725 257.329 82.9641 257.286 83.3344 257.38C85.3154 257.971 86.8973 257.605 89.7584 256.309C92.1101 255.241 92.7186 252.568 91.1734 250.423L90.7744 249.877L89.1217 247.698L89.0453 247.596C87.6727 245.732 87.0473 244.127 87.1067 242.217L87.152 240.229C87.1747 238.976 87.1803 237.638 87.1747 235.802L87.1492 229.336V228.751C87.1503 228.59 87.1607 228.43 87.1803 228.271L87.2058 228.06C87.2228 227.955 87.2398 227.844 87.2652 227.711L87.5199 226.41C87.6529 225.722 87.7746 225.029 87.9189 224.176L88.7679 218.886L89.1273 216.875L89.5858 214.355C89.8688 212.738 90.0414 211.696 90.1801 210.568L90.3103 209.497C90.3499 209.178 90.398 208.84 90.4603 208.423L90.6612 207.084C91.1847 203.627 91.3489 201.993 91.247 199.982L91.2102 199.3C91.1083 197.717 90.9272 196.115 90.6442 193.973L90.2508 191.18L90.166 190.649C90.1348 190.464 90.1009 190.268 90.0584 190.046L89.7754 188.649C89.5436 187.623 89.4316 186.575 89.4415 185.523L89.4868 184.299C89.5235 183.097 89.5292 181.841 89.5151 180.015L89.4839 176.483V176.017C89.5087 175.551 89.4414 175.085 89.2858 174.645C88.5274 172.744 88.7057 171.13 89.6962 167.985L89.8094 167.63C91.2436 163.202 92.0922 158.603 92.3337 153.953L92.4073 152.615L92.7242 147.885C93.0072 143.651 93.044 141.276 92.8573 138.594L92.2686 131.412C92.0592 128.934 91.8837 126.985 91.7026 125.113L91.2583 120.795C90.9753 118.218 90.7546 116.874 90.2791 115.252L90.098 114.652C90.0556 114.513 90.0103 114.368 89.9622 114.226L89.2207 112.019C88.0519 108.496 87.7605 106.734 88.185 104.461V103.85C88.185 103.595 88.2048 103.319 88.2246 102.944L88.2699 102.055C88.3293 100.634 88.3038 99.8587 88.1255 99.0035L87.9925 98.4182L87.2256 95.2532C86.9426 94.0685 86.7898 93.3043 86.6596 92.4122C86.3257 90.3069 86.3766 88.4346 86.9426 86.6504L87.2256 85.6816C87.6699 84.1559 88.0746 82.6075 88.6802 80.0676L89.4754 76.7691L89.5518 76.4338C89.5858 76.2975 89.6141 76.2719 89.6933 76.2634H89.7386C89.7944 76.2473 89.8529 76.243 89.9105 76.2506C89.968 76.2583 90.0233 76.2778 90.073 76.308C90.1227 76.3381 90.1656 76.3782 90.1992 76.4258C90.2327 76.4733 90.2561 76.5273 90.2678 76.5844L90.5508 77.2265L91.3998 79.184C91.4989 79.417 91.5809 79.6159 91.6658 79.8233L91.8951 80.3915L93.344 83.8832C94.51 86.7413 95.042 88.4005 95.325 90.3239L95.492 91.5996C95.775 93.8725 96.058 95.1737 96.5815 96.5289C98.4687 101.272 100.665 105.886 103.156 110.339L103.755 111.411C105.261 114.067 106.235 116.411 106.761 118.854L108.334 126.136L108.965 129.108L109.65 132.264C110.165 134.522 110.561 136.806 110.836 139.106L110.898 139.705C110.941 140.199 110.969 140.682 110.992 141.378L111.051 143.631C111.068 144.149 111.088 144.524 111.119 144.953C111.207 146.123 111.685 146.981 112.704 146.941C113.527 146.919 113.85 146.373 113.915 145.521V145.237L113.935 142.003C113.935 141.56 113.949 141.188 113.963 140.787C113.977 140.387 114.091 140.219 114.357 140.188H114.436C114.49 140.188 114.512 140.188 114.538 140.282L114.634 140.64L114.79 141.154C115.063 142.088 115.283 143.036 115.449 143.995L115.712 145.487C115.757 145.731 115.8 145.938 115.848 146.166C116.196 147.848 117.52 149.609 118.542 149.081C119.66 148.512 119.807 147.788 119.484 146.461L119.343 145.893C119.343 145.833 119.317 145.779 119.309 145.728L119.218 145.16C119.17 144.876 119.114 144.592 119.029 144.22L118.746 142.969C118.549 142.197 118.435 141.405 118.406 140.608V140.012C118.406 139.89 118.423 139.895 118.505 139.887C118.587 139.878 118.604 139.91 118.681 140.086L118.87 140.603L120.155 144.234L120.308 144.663C120.345 144.771 120.384 144.89 120.432 145.052L120.662 145.808C120.82 146.409 121.088 146.975 121.451 147.478L121.615 147.694L121.799 147.958C122.365 148.765 122.931 149.078 123.78 148.592C124.793 148.01 125.102 147.052 124.629 145.961L124.372 145.393C124.25 145.109 124.128 144.825 123.995 144.472L122.663 140.992C122.396 140.276 122.215 139.756 122.02 139.165C121.845 138.631 121.85 138.344 122.02 138.219L122.074 138.191C122.097 138.191 122.102 138.168 122.108 138.191L122.227 138.515C122.274 138.651 122.337 138.782 122.413 138.904L122.979 139.756L125.459 143.708L125.897 144.39C126.381 145.146 126.885 145.481 127.666 145.18C128.532 144.847 128.75 144.143 128.673 143.04C128.628 142.347 128.433 141.876 127.912 141.02L127.533 140.401C127.448 140.259 127.389 140.148 127.329 140.035L126.99 139.336C126.811 138.975 126.61 138.594 126.339 138.083L125.614 136.736C124.553 134.747 124.061 133.673 123.653 132.384L123.537 132.023L123.458 131.784C123.362 131.466 123.373 131.409 123.526 131.327C123.828 131.168 124.151 131.278 124.527 131.67L125.996 133.207C126.636 133.881 127.063 134.344 127.539 134.884C127.871 135.295 128.315 135.6 128.818 135.762C129.559 135.986 130.233 135.864 130.688 135.316C131.144 134.767 131.062 134.367 130.688 133.807Z"
                            fill="#D0D2D6" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M44.4913 206.786C44.3536 204.084 44.7189 201.409 45.1848 198.75C45.6391 196.157 45.9592 193.539 46.4449 190.952C46.71 189.542 49.0194 189.128 50.2615 190.264C51.1323 191.061 51.7492 192.061 52.1814 193.183C54.074 198.097 54.5413 203.278 55.0796 208.445C55.5803 213.252 55.6779 218.058 54.8869 222.845C54.335 226.186 53.7107 229.514 52.1021 232.554C51.9195 232.899 51.7294 233.254 51.4731 233.543C51.0082 234.068 50.4501 234.541 49.6978 234.42C48.9021 234.292 49.0706 233.493 48.9287 232.978C48.66 232.004 48.5302 230.993 48.2435 230.004C48.2435 230.004 45.0027 216.814 44.4913 206.786Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M56.6698 223.221C56.0467 219.518 56.511 215.767 56.0966 212.052C55.759 209.028 55.4194 205.995 55.4744 202.943C55.4918 201.964 55.6379 200.986 55.7452 200.011C55.8155 199.369 56.2361 198.662 56.7525 198.703C58.3233 198.828 58.3304 198.764 58.8571 201.665C59.4563 204.966 60.3052 208.261 59.8497 211.631C59.4761 214.392 58.936 217.14 58.1784 219.835L56.6698 223.221Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M78.1943 199.127C78.8883 199.15 79.1792 200.053 79.1673 200.707C79.1056 204.05 78.3341 217.883 78.0725 220.459C77.9519 221.646 77.2026 222.775 77.403 224.025C74.4962 216.855 74.3339 205.025 75.515 200.603C75.9094 199.127 77.784 199.113 78.1943 199.127Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M79.199 216.176C79.6028 208.515 79.9791 201.697 81.9433 195.105C82.3985 193.577 82.8572 191.986 84.0612 190.783C84.7688 190.076 85.5613 189.709 86.5731 189.881C87.6478 190.064 87.7557 190.957 87.9224 191.76C88.8819 196.375 89.774 201.021 89.7441 205.743C89.7299 207.968 89.0847 210.188 88.7335 212.412C87.9771 217.202 87.0806 221.969 86.4859 226.786C86.2169 228.967 85.7309 231.121 85.3517 233.289C85.2881 233.652 85.1882 233.958 84.7629 234.021C84.1741 234.107 83.6881 233.927 83.3367 233.447C82.6083 232.453 81.9773 231.397 81.5838 230.226C80.551 227.15 79.9389 223.974 79.6383 220.759C79.4701 218.959 79.05 217.162 79.199 216.176Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M90.9258 150.972C91.2557 157.205 89.4171 162.86 86.9759 168.389C84.9904 172.884 79.6609 172.986 76.5236 171.508C75.7329 171.135 75.2318 170.447 75.0823 169.434C74.6605 166.574 74.1048 163.727 74.0202 160.833C73.9174 157.304 74.8355 153.928 75.878 150.6C78.2782 142.937 81.3319 135.516 84.3853 128.098C84.8263 127.028 85.2407 125.913 85.9868 124.965C87.1508 123.487 88.2741 123.564 89.1038 125.278C89.6891 126.487 89.9477 127.808 90.0186 129.127C90.2791 133.981 90.5244 138.836 90.6618 143.694C90.7313 146.148 91.1552 148.589 90.9258 150.972Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M43.2502 149.271C42.9842 142.687 43.7243 136.567 43.8807 130.426C43.9248 128.694 44.1243 126.908 44.8718 125.249C45.1993 124.522 45.565 123.887 46.3557 123.772C47.2055 123.647 47.7059 124.336 48.0784 124.947C49.2084 126.799 49.9506 128.841 50.7792 130.837C53.6351 137.719 56.2685 144.68 58.544 151.781C60.193 156.927 60.199 162.091 59.2418 167.325C59.1801 167.663 59.0476 168.012 59.0855 168.339C59.3409 170.559 57.4033 172.036 55.1181 172.22C50.5161 172.589 48.2921 171.298 46.4186 166.924C43.9327 161.121 42.6398 155.159 43.2502 149.271Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M63.8442 144.412C63.4756 147.724 63.1422 151.041 62.7133 154.345C62.6051 155.179 62.6048 156.008 62.5338 156.838C62.5102 157.114 62.6042 157.488 62.2409 157.591C61.8235 157.711 61.5856 157.361 61.4703 157.061C61.2075 156.375 60.9652 155.672 60.8171 154.955C59.7872 149.963 58.8065 144.962 57.3395 140.071C56.8526 138.448 57.1663 136.896 58.017 135.402C58.5555 134.457 59.165 134.435 59.9439 134.944C60.8188 135.516 61.5469 136.242 62.0417 137.178C63.2368 139.437 63.9101 141.818 63.8442 144.412Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M76.9914 138.071C76.9952 140.044 76.517 141.619 76.0015 143.124C74.7697 146.721 74.418 150.5 73.4706 154.15C73.2126 155.144 72.9087 156.127 72.5963 157.106C72.5088 157.379 72.3196 157.665 71.9708 157.621C71.6622 157.582 71.6628 157.285 71.6466 157.045C71.3196 152.257 70.2582 147.529 70.4453 142.701C70.5455 140.121 71.4255 137.787 73.0905 135.83C74.682 133.96 75.8052 134.22 76.6281 136.535C76.8392 137.129 76.9222 137.769 76.9914 138.071Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M52.1659 123.866C52.2572 123.081 51.9803 122.365 52.6826 122.073C53.3231 121.807 53.8111 122.312 54.2315 122.696C56.5258 124.792 58.2438 127.371 60.1246 129.813C60.6714 130.523 60.3667 131.032 59.6815 131.326C58.8361 131.689 57.965 132.032 57.0712 132.231C55.8814 132.497 55.0494 132.008 54.4416 130.888C53.2058 128.61 52.6164 126.157 52.1659 123.866Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M81.9948 124.147C81.5496 126.458 80.8009 129.018 79.4252 131.357C79.0235 132.04 78.3866 132.395 77.5636 132.266C77.0351 132.184 76.4989 132.106 75.9905 131.948C73.374 131.136 73.2752 130.816 74.906 128.649C76.4357 126.616 77.9571 124.575 79.821 122.828C80.2706 122.406 80.7581 121.77 81.4426 122.087C82.1098 122.396 81.9812 123.166 81.9948 124.147Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M49.414 47.2874C46.7256 46.7346 44.0405 46.0102 41.285 46.9447C41.0598 47.0209 36.5435 49.0516 35.4782 52.413C34.5238 55.4251 34.2243 58.359 35.3981 61.3295C36.2958 63.6015 39.1405 64.2566 41.0069 62.6738C41.3223 62.4064 41.5005 62.0805 41.5354 61.6598C41.6324 60.4883 41.7931 59.3204 41.8467 58.1472C42.0101 54.5656 43.9424 52.0643 47.3753 50.9971C48.827 50.5457 50.2665 50.0514 51.6903 49.5193C52.0693 49.3775 52.6415 49.4286 52.7624 48.8802C52.9259 48.1389 49.693 47.3447 49.414 47.2874Z"
                            fill="#BFC4CB" />
                        <path id="shape1" fill-rule="evenodd" clip-rule="evenodd"
                            d="M59.2459 41.7466C58.7159 41.4222 58.3263 41.8565 57.9296 42.1123C55.6229 43.6014 53.4258 45.2719 50.8666 46.3409C50.7185 46.4029 50.4415 46.493 50.3404 46.6233C50.1982 46.8065 50.5039 46.9628 50.6653 47.0293C50.8414 47.1017 55.8389 48.376 57.1791 48.6138C58.7877 48.8989 59.0354 48.6602 59.3224 47.0659C59.5687 45.6997 59.6154 44.3336 59.6062 42.9576C59.6033 42.5212 59.6905 42.0187 59.2459 41.7466Z"
                            :fill="colorLevels[1]" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M90.9307 46.5489C88.8912 46.3302 86.9202 46.7551 84.9746 47.294C84.7603 47.3537 84.5507 47.4018 84.3388 47.4287C83.8236 47.6007 83.3081 47.7729 82.7926 47.9452C82.6885 47.9797 82.5833 48.0111 82.4772 48.0374C82.0604 48.3104 81.401 48.2321 81.4477 48.8011C81.5065 49.5179 82.3321 49.434 82.8473 49.6192C83.7698 49.951 84.7095 50.2447 85.6586 50.4896C88.5696 51.2407 90.8752 52.7277 91.9594 55.6692C92.5964 57.3977 92.3957 59.2525 92.5777 61.043C92.7211 62.4544 93.547 62.9817 94.6052 63.435C95.6524 63.8841 96.658 63.9446 97.5962 63.0905C99.1702 61.6578 99.4998 59.7356 99.7765 57.7868C100.073 55.6967 99.4555 47.4633 90.9307 46.5489Z"
                            fill="#BFC4CB" />
                        <path id="shape2" fill-rule="evenodd" clip-rule="evenodd"
                            d="M83.5613 47.1472C83.6639 47.1011 83.7865 47.0509 83.8551 46.9732C83.8643 46.9561 83.8767 46.938 83.8829 46.9209L83.8903 46.9177C83.9122 46.8683 83.9148 46.8095 83.8811 46.7357C83.8013 46.5631 83.5595 46.4792 83.3961 46.4192C81.5909 45.7565 80.0222 44.632 78.4237 43.5793C77.6052 43.0404 76.7873 42.4956 75.9342 42.0146C75.1758 41.5868 74.6165 41.6482 74.5911 42.7317C74.5538 44.3076 74.6159 45.8738 74.9233 47.4214C75.0809 48.2138 75.427 48.8239 76.4128 48.6405C77.7613 48.389 79.105 48.0912 80.4647 47.9263C80.8449 47.88 81.2338 47.7169 81.6314 47.6486C81.7378 47.6069 81.8504 47.5771 81.9619 47.5517C82.4966 47.43 83.0564 47.3747 83.5613 47.1472Z"
                            :fill="colorLevels[2]" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M47.1287 107.354C47.3161 104.347 47.5602 100.464 48.4633 96.606C49.212 93.4074 49.2516 90.0567 48.3565 86.8309C47.3515 83.2081 48.7364 80.4662 51.3006 78.1159C52.4129 77.0963 52.8108 77.2213 53.5066 78.5343C54.0508 79.5613 54.3029 80.7038 54.1678 81.8061C53.9568 83.5286 54.0768 85.2089 54.1988 86.9222C54.3475 89.0007 54.3342 91.1186 54.3401 93.1755C54.3463 95.4606 54.443 97.8469 54.0366 100.141C53.6 102.606 54.5769 104.892 54.7271 107.281C54.85 109.233 55.2115 111.17 55.1527 113.143C55.1146 114.423 54.6541 115.424 53.5308 116.073C52.4655 116.687 51.799 115.821 51.0245 115.368C50.94 115.319 50.8628 115.256 50.7815 115.201C47.181 112.755 47.0642 112.534 47.1287 107.354Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M86.055 84.6344C85.1327 87.8868 85.4416 91.2242 85.3438 94.5404C85.3003 96.0061 85.8209 97.3351 86.0692 98.7208C86.7026 102.254 86.8528 105.82 87.164 109.379C87.3307 111.285 86.7298 112.722 85.1546 113.794C84.3048 114.373 83.5188 115.047 82.6622 115.614C81.3847 116.461 80.3744 116.154 79.6845 114.757C79.2121 113.801 79.1199 112.767 79.2358 111.734C79.5792 108.669 79.7034 105.567 80.5502 102.581C80.7506 101.874 80.3554 101.343 80.3445 100.73C80.2895 97.6725 79.8772 94.601 80.2804 91.5628C80.4358 90.3919 80.1009 89.333 80.153 88.2165C80.2549 86.0239 80.4255 83.8417 80.228 81.6311C80.1042 80.241 80.2221 78.4053 81.7066 77.9358C83.1813 77.4696 83.8289 79.2326 84.5744 80.246C85.5081 81.515 86.2238 82.9367 86.055 84.6344Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M64.365 104.904C62.0996 105.035 58.1806 104.547 57.7406 104.552C56.4144 104.64 55.8924 105.446 55.9473 106.795C56.003 108.175 56.2297 109.509 56.4367 110.867C57.0353 114.798 57.6692 118.718 58.6875 122.56C59.1835 124.433 59.7724 126.325 61.123 127.804C61.9766 128.738 63.0413 129.509 64.3895 129.064C65.7461 128.616 66.4614 127.649 66.6503 126.11C67.3465 120.445 67.0815 114.731 67.0749 109.04C67.0726 106.813 67.3451 105.327 65.6992 104.973L64.8184 104.892C64.6754 104.891 64.5259 104.895 64.365 104.904Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M70.5142 104.904C72.7796 105.035 76.6986 104.547 77.1386 104.552C78.4648 104.64 78.9868 105.446 78.9319 106.795C78.8762 108.175 78.6495 109.509 78.4425 110.867C77.8438 114.798 77.21 118.718 76.1917 122.56C75.6957 124.433 75.1067 126.325 73.7562 127.804C72.9025 128.738 71.8379 129.509 70.4896 129.064C69.1331 128.616 68.4178 127.649 68.2288 126.11C67.5327 120.445 67.7977 114.731 67.8043 109.04C67.8066 106.813 67.5341 105.327 69.18 104.973L70.0608 104.892C70.2038 104.891 70.3533 104.895 70.5142 104.904Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M78.6008 94.0885C79.063 92.1919 79.895 89.7046 77.7297 88.1021C75.8405 86.7036 71.8001 84.0778 69.5038 83.4677C67.6075 82.9639 67.7067 84.8573 67.5652 86.0789L67.6412 90.7262C67.7882 91.4961 67.4648 92.3353 68.028 93.014C68.7187 93.8461 69.7565 93.7438 70.9504 93.8133C69.6322 93.9856 68.1793 93.5061 67.7073 94.7883L67.7379 96.6669C67.7379 97.9336 67.727 99.2007 67.743 100.467C67.7502 101.01 67.7096 101.519 67.8482 102.112C68.0761 103.085 68.5987 103.823 69.143 103.926C74.8202 104.999 77.4298 103.19 77.4298 103.19C79.2043 101.249 78.6282 98.8889 78.485 96.6186C78.4312 95.7647 78.3738 95.0206 78.6008 94.0885Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M56.0718 94.0885C55.6095 92.1919 54.7776 89.7046 56.9429 88.1021C58.8321 86.7036 62.8725 84.0778 65.1688 83.4677C67.0651 82.9639 66.9659 84.8573 67.1074 86.0789L67.0314 90.7262C66.8844 91.4961 67.2078 92.3353 66.6446 93.014C65.9538 93.8461 64.9161 93.7438 63.7222 93.8133C65.0404 93.9856 66.4933 93.5061 66.9653 94.7883L66.9347 96.6669C66.9347 97.9336 66.9456 99.2007 66.9296 100.467C66.9224 101.01 66.963 101.519 66.8244 102.112C66.5965 103.085 66.0739 103.823 65.5296 103.926C59.8524 104.999 57.2428 103.19 57.2428 103.19C55.4683 101.249 56.0444 98.8889 56.1876 96.6186C56.2414 95.7647 56.2988 95.0206 56.0718 94.0885Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M69.6043 82.9704C70.0546 83.1167 74.2434 84.649 76.7564 86.637C77.1586 86.9551 77.5626 87.4354 78.1312 87.2177C78.735 86.9865 78.6275 86.343 78.6347 85.8472C78.665 83.7523 78.7513 81.6514 78.6338 79.563C78.4746 76.7294 77.367 75.4755 74.9904 74.7731C73.29 74.2708 71.5298 74.097 69.7635 74.2796C68.4945 74.4105 67.7297 75.0306 67.6394 76.4711C67.5648 77.6582 67.5633 78.8478 67.4696 80.0311C67.4007 80.903 67.4847 81.8663 68.2561 82.4158C68.4087 82.5244 69.4988 82.9361 69.6043 82.9704Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M65.0635 82.9704C64.6133 83.1167 60.4244 84.649 57.9115 86.637C57.5092 86.9551 57.1053 87.4354 56.5366 87.2177C55.9328 86.9865 56.0403 86.343 56.0332 85.8469C56.0029 83.7523 55.9165 81.6514 56.034 79.563C56.1933 76.7294 57.3008 75.4755 59.6774 74.7731C61.3779 74.2708 63.1381 74.097 64.9043 74.2796C66.1733 74.4105 66.9381 75.0306 67.0284 76.4711C67.1031 77.6582 67.1045 78.8481 67.1983 80.0311C67.2672 80.903 67.1831 81.8663 66.4118 82.4158C66.2591 82.5244 65.169 82.9361 65.0635 82.9704Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M79.1398 74.1586C76.9279 73.9509 74.2345 73.8981 71.6635 72.869C69.9491 72.1826 68.986 71.2183 68.7735 69.2482C68.2616 64.4976 67.7605 59.7319 68.9133 55.0543C69.8908 51.0869 70.845 50.0608 74.943 50.038C79.4073 50.0132 83.6014 51.0479 87.3267 53.582C90.0062 55.405 90.8711 57.9193 90.2711 61.1448C89.8493 63.413 89.5386 65.6785 88.6879 67.8474C88.1059 69.3309 87.3453 70.6947 86.3442 71.912C84.5842 74.0511 82.0969 74.125 79.1398 74.1586Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M66.1939 68.2328C66.5303 65.088 66.4008 61.9446 66.4626 58.8001C66.4999 56.8994 66.0464 55.0986 65.3855 53.3362C64.7825 51.7287 63.5957 50.689 61.9649 50.392C56.1324 49.3308 50.7858 50.6795 46.1282 54.2545C44.0156 55.8763 43.2486 58.2819 44.0142 61.0074C44.7416 63.5977 45.4622 66.19 46.4894 68.6798C47.9567 72.2356 50.4116 74.2863 54.4934 74.175C56.3251 74.1247 58.9369 74.193 60.6992 73.6018C61.0986 73.4676 61.8437 73.3465 62.1668 73.2455C65.2578 72.277 65.8549 71.4039 66.1939 68.2328Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M32.636 54.0128C33.1837 53.9946 33.8798 56.2256 33.8778 56.5266C33.865 58.3372 33.8621 60.1398 34.4775 61.8818C34.8494 62.9339 35.4272 63.7585 36.4571 64.308C37.7372 64.9905 37.7517 65.3392 36.6708 66.3558C35.8886 67.0915 35.1148 67.8603 34.2301 68.4553C33.2097 69.1414 31.9473 70.8136 31.7569 71.1248C30.0579 73.8973 32.7344 65.1643 31.4882 61.5928C30.7324 59.4268 31.4575 56.1083 32.636 54.0128Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M102.351 70.1998C100.719 68.8741 98.4695 67.4594 97.0066 65.9287C96.5068 65.4051 96.2836 64.9779 97.108 64.5873C99.3731 63.5142 100.066 61.6487 100.337 59.4169C100.618 57.1064 101.32 54.9709 101.123 52.9077C101.999 54.6725 101.954 57.5594 102.208 59.5495C102.658 63.082 102.422 66.7246 102.351 70.1998Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M20.4576 114.606C20.8776 109.776 21.5134 104.986 22.4232 100.211C23.1403 96.4458 24.1586 92.8147 25.5559 89.2678C25.9549 88.2553 26.5065 87.3269 27.2085 86.4988C27.6359 85.9941 28.0506 85.6139 28.4331 86.6199C29.2826 88.8538 30.9279 90.3104 33.1011 91.2588C36.3445 92.675 35.7498 93.1574 34.9497 95.5571C32.7792 102.068 30.1898 108.432 26.166 114.092C25.5594 114.946 24.8352 115.665 24.0519 116.333C23.1684 117.086 22.0605 117.393 21.0212 116.98C19.9252 116.544 20.6798 115.41 20.4576 114.606Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M113.376 114.606C112.956 109.776 112.32 104.986 111.41 100.211C110.693 96.4458 109.675 92.8147 108.278 89.2678C107.878 88.2553 107.327 87.3269 106.625 86.4988C106.197 85.9941 105.783 85.6139 105.4 86.6199C104.551 88.8538 102.905 90.3104 100.732 91.2588C97.4888 92.675 98.0836 93.1574 98.8837 95.5571C101.054 102.068 103.644 108.432 107.667 114.092C108.274 114.946 108.998 115.665 109.781 116.333C110.665 117.086 111.773 117.393 112.812 116.98C113.908 116.544 113.154 115.41 113.376 114.606Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M43.2456 67.8997C42.684 74.6216 40.8605 80.5496 37.0108 85.9889C36.0374 87.3642 35.5 88.7871 33.5234 88.4725C31.9429 88.2207 31.6184 87.0478 31.3361 85.8731C30.0763 80.6358 31.013 75.705 33.4356 70.9582C33.9996 69.8529 34.8888 69.1246 35.7064 68.3003C37.4326 66.561 39.2395 64.9067 41.1555 63.3715C42.2158 62.5221 42.679 62.8533 42.8167 64.0703C42.9707 65.43 43.1215 66.7899 43.2456 67.8997Z"
                            fill="#BFC4CB" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M91.0727 67.8391C91.0641 66.4511 91.3801 65.1115 91.5622 63.7521C91.7206 62.5703 92.2618 62.7118 92.8814 63.2262C94.3762 64.4665 95.8302 65.7588 97.2768 67.0574C102.403 71.6596 103.955 77.4825 102.906 84.1851C102.8 84.8623 102.672 85.5366 102.594 86.2173C102.288 88.8852 99.4949 89.1907 97.7349 87.605C95.5896 85.6722 94.8459 83.0745 93.8574 80.4754C92.315 76.4182 91.3612 72.1613 91.0727 67.8391Z"
                            fill="#BFC4CB" />
                    </svg>
        </div>-->

        <!-- <div class="assessmentInfo">

        <ul class="assessmentTxts">-->
        <!-- 循环提示列表 -->
        <!-- <li v-for="(itm, inx) in 2" :key="'itm' + inx">
                            <div v-if="inx !== 1" class="verLine"></div><span>胸锁乳突肌、斜角肌 </span>紧张→头侧歪+颈部过伸
                        </li>
                    </ul>
                </div>
            </div>
        </div>-->
    </div>
</template>

<script>
import processBar from '../../components/public/processBar.vue'
export default {
    components: {
        processBar,
    },
    props: {
        painRisk: Object,
    },
    data() {
        return {
            tabinx: 0,
            // 等级色值
            colorLevels: ['#51ED97', '#EAB04D', '#FD3741'],
            // 等级
            0: 0,
            preScore: 0, // 当前状态评分
            preStatus: 0, // 当前状态值
            interval: [0, 11, 40, 60],
        }
    },
    created() {
        this.init()
    },
    methods: {
        init() {
            this.tabinx = 0
            this.preScore = Math.round(this.painRisk.cervicalPainScore)
            this.preStatus = this.painRisk.cervicalPainStatus
            this.interval = [0, 11, 40, 60]
        },
        onChange(index) {
            this.tabinx = index
            switch (index) {
                case 0:
                    this.preScore = Math.round(this.painRisk.cervicalPainScore)
                    this.preStatus = this.painRisk.cervicalPainStatus
                    this.interval = [0, 11, 40, 60]
                    break
                case 1:
                    this.preScore = Math.round(this.painRisk.thoracicPainScore)
                    this.preStatus = this.painRisk.thoracicPainStatus
                    this.interval = [0, 15, 30, 50]
                    break
                case 2:
                    this.preScore = Math.round(this.painRisk.lumbarPainScore)
                    this.preStatus = this.painRisk.lumbarPainStatus
                    this.interval = [0, 10, 25, 40]
                    break
            }
        },
        dealWith(key) {
            switch (key) {
                case 0:
                    return this.$t('di-feng-xian')
                case 1:
                    return this.$t('zhong-feng-xian')
                case 2:
                    return this.$t('gao-feng-xian')
            }
        },
    },
}
</script>

<style lang="less" scoped>
.cardBox {
    margin: 0 auto 24px;
    width: 351px;
    min-height: 219px;
    background: url(../../assets/image/spine/bg1.png) 0 0;
    background-size: 100% 100%;
    border-radius: 6px 6px 6px 6px;
    border: 2px solid #3f537c;
    padding-bottom: 10px;
    position: relative;

    .anchor {
        position: absolute;
        top: -10px;
    }

    .cardTitle {
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        text-align: center;
        background: url(../../assets/image/spine/titlebg.png) 0 0;
        background-size: 100% 100%;
        width: 100%;
        height: 44px;
        line-height: 44px;
    }

    .chartBox {
        width: 352px;
        min-height: 164px;

        .rateNum {
            width: 80px;
            height: 100%;
            display: inline-block;
            margin-left: 25px;
            vertical-align: top;
            text-align: center;

            p {
                font-weight: 500;
                font-size: 14px;
                color: #ffffff;
                margin: 9px 0 11px;
            }

            img {
                width: 80px;
                height: 100px;
            }
        }

        .chartCircle {
            width: calc(100% - 136px);
            height: 164px;
            display: inline-block;
            border: 1px solid red;
            margin-left: 20px;
        }

        .tips {
            height: 40px;
            padding-top: 16px;
            font-weight: 400;
            font-size: 12px;
            color: #8aa3be;
            line-height: 18px;
            margin: 0 13px;
            border-top: 1px dashed #8a90a2;
        }
    }

    .customTabs {
        width: 330px;
        height: 189px;
        background: rgba(8, 20, 59, 0.75);
        border-radius: 6px 6px 6px 6px;
        margin: 17px auto 0;

        .tabsTitle {
            width: 330px;
            height: 38px;
            box-sizing: border-box;
            background: linear-gradient(
                to right,
                rgba(255, 255, 255, 0) 0%,
                rgba(255, 255, 255, 0.1) 50%,
                rgba(255, 255, 255, 0) 100%
            );
            border-radius: 6px 6px 0px 0px;
            display: flex;
            padding: 0 29px;
            align-items: flex-end;
            justify-content: space-between;

            li {
                width: 75px;
                height: 27px;
                font-size: 15px;
                color: #8aa3be;
                line-height: 15px;
                position: relative;
                text-align: center;
            }

            .currentTab {
                position: relative;
                background: linear-gradient(to right, #00e3c9, #009fe8);
                /* 红粉色到纯红渐变 */
                background-clip: text;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;

                &::before {
                    content: '';
                    width: 60px;
                    height: 3px;
                    border-radius: 6px 6px 0 0;
                    background: linear-gradient(90deg, #00e3c9 0%, #009fe8 100%);
                    position: absolute;
                    bottom: 0;
                    left: 8px;
                    left: 50%; // ✅ 左边在中点
                    transform: translateX(-50%);
                }
            }
        }

        .rateBox {
            width: 100%;
            height: 130px;
            margin: 0 14px;
            // padding-top: 13px;
            display: flex;

            .rateImg {
                width: 70px;
                height: 70px;
                background: rgb(24, 35, 71);
                border-radius: 6px;
                margin-top: 10px;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .rateProcess {
                width: 206px;
                height: auto;
                margin-left: 13px;

                p {
                    &:nth-child(1) {
                        margin-top: 13px;
                        display: flex;
                        justify-content: space-between;

                        span {
                            &:first-child {
                                font-weight: 600;
                                font-size: 24px;
                                // color: #FD3741;
                            }

                            &:last-child {
                                // width: 68px;
                                // height: 24px;
                                padding: 3px 10px;
                                // background: #A64045;
                                border-radius: 6px 6px 6px 6px;
                                font-weight: 400;
                                font-size: 13px;
                                color: #ffffff;
                                text-align: center;
                                line-height: 26px;
                            }
                        }
                    }
                    i {
                        font-style: normal;
                        font-size: 12px;
                        color: #8aa3be;
                        font-weight: 400;
                        vertical-align: middle;
                    }
                }
            }
        }

        .tips {
            height: 40px;
            padding-top: 10px;
            font-weight: 400;
            font-size: 12px;
            color: #8aa3be;
            line-height: 18px;
            margin: 0 13px;
            border-top: 1px dashed #8a90a2;
        }
    }

    .assessmentView {
        width: 330px;
        min-height: 127px;
        margin-left: 10px;
        background: #364869;
        border-radius: 0 0 6px 6px;

        .assessmentTitle {
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;
            margin-left: 11px;
            padding-top: 11px;

            span {
                display: inline-block;
                width: 16px;
                height: 16px;
                background: #eab04d;
                border-radius: 50%;
                text-align: center;
                line-height: 16px;
                color: #1c1e3b;
                font-size: 14px;
                margin-right: 10px;
            }
        }

        .assessmentDetail {
            width: 330px;
            min-height: 103px;
            border-radius: 6px 6px 6px 6px;
            margin: 0 auto;
            padding: 10px 13px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            .shapeBox {
                width: 310px;
                height: 75px;
                border-radius: 6px;
                background-color: rgb(67, 76, 104);
            }

            img {
                width: 75px;
                height: 75px;
            }

            .assessmentInfo {
                display: flex;

                .assessmentTxts {
                    width: 100%;
                    font-size: 12px;
                    color: #ffffff55;
                    line-height: 18px;
                    margin-bottom: 6px;
                    position: relative;

                    li {
                        position: relative;
                        margin-left: 26px;
                        margin-bottom: 6px;

                        &::before {
                            position: absolute;
                            content: '';
                            width: 9px;
                            height: 9px;
                            border-radius: 50%;
                            left: -16px;
                            top: 6px;
                            background-color: #eab04d;
                        }

                        .verLine {
                            position: absolute;
                            width: 1px;
                            height: 105%;
                            background-color: #eab04d;
                            left: -12px;
                            top: 10px;
                        }
                    }

                    span {
                        color: #ffffff;
                    }
                }
            }
        }
    }
}
.assessmentTxts li::after {
    position: absolute;
    content: '';
    width: 1px; /* 线段宽度 */
    height: 100%; /* 线段高度 */
    background-color: #eab04d; /* 线段颜色 */
    left: -13px; /* 线段左侧位置 */
    top: 12px; /* 线段顶部位置 */
}

.assessmentTxts li:last-child::after {
    display: none; /* 对于最后一个项目，不显示线段 */
}
.tips2 {
    text-align: left;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    padding: 5px 14px;
}
&.en-US,
&.pl-PL {
    .tabsTitle {
        li {
            height: 34px !important;
            display: flex; /* 使用Flexbox布局 */
            align-items: center; /* 垂直居中 */
            justify-content: center; /* 水平居中 */
        }
    }
    .rateProcess {
        p {
            flex-direction: column;

            span {
                &:first-child {
                    align-self: flex-start;
                }
                &:last-child {
                    // min-width: 0px;
                    align-self: flex-start;
                }
            }
        }
    }
}
&.ar-AR {
    .chartBox {
        .rateNum {
            margin-left: auto;
            margin-right: 25px;
        }
        .chartCircle {
            margin-left: auto;
            margin-right: 20px;
        }
    }

    .customTabs {
        .tips2 {
            text-align: right;
        }
        .rateBox {
            .rateProcess {
                margin-left: auto;
                margin-right: 13px;
            }
        }
    }

    .assessmentView {
        margin-left: 10px;
        margin-right: 10px;
        .assessmentTitle {
            margin-left: auto;
            margin-right: 11px;
            span {
                margin-left: 10px;
                margin-right: auto;
            }
        }

        .assessmentDetail {
            .assessmentInfo {
                display: flex;
                .assessmentTxts {
                    li {
                        margin-left: 26px;
                        margin-right: 26px;
                        &::before {
                            left: auto;
                            right: -16px;
                        }
                        .verLine {
                            left: auto;
                            right: -12px;
                        }
                    }
                }
            }
        }
    }
}
</style>